
<div class="Survey-main">
<survey-header [getsurveyelement]="getsurveyelement" [getrestaurantaddress]="getsurveyproperty" [commentcardStyles]="commentcardStyles"></survey-header>
<activity-summary [getsurveyelement]="getsurveyelement" [isdatavalid]="isdatavalid" [isvalid]="isvalid" [commentcardStyles]="commentcardStyles"></activity-summary>
<span *ngIf="isvalid && isdatavalid">
<survey-form [getsurveyaddress]="getsurveyelement" [isdatavalid]="isdatavalid" [commentcardStyles]="commentcardStyles"></survey-form>
</span>
</div>
<survey-footer [commentcardStyles]="commentcardStyles"></survey-footer>